import MicroModal from "micromodal";

export default class CareersBlock {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        var modal = document.querySelector('#careers-modal');
        if (modal) {
            MicroModal.init();
        }
        let careerButtons = document.querySelectorAll('.careers-block__more-details');
        if (careerButtons) {
            careerButtons.forEach(button => {
                button.onclick = () => {
                    var modalTitle = document.querySelector('#careers-modal-title');
                    var modalContent = document.querySelector('#careers-modal-content');
                    let id = button.getAttribute('data-id');
                    this.fetchModalContent(id).then(response => {
                        modalTitle.innerHTML = response['title']['rendered'];
                        modalContent.innerHTML = response['career_content'];
                        MicroModal.show('careers-modal');
                    }).catch(error => {
                        modalContent.innerHTML = error;
                    });
                }
            });
        }
    }

    async fetchModalContent(id) {
        let origin = window.location.origin;
        let url = `${origin}/wp-json/wp/v2/career/${id}`;

        const response = await fetch(url);

        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson ? await response.json() : null;

        if (!response.ok) {
            const message = `An error has occurred fetching the career: ${response.status}`;
            throw new Error(message);
        }
        return data;
    }
}